export class userAccount{
    _id:any;
    userId:any;
    accountId:any;
    companyName:any;
    companySize:any;
    address:any;
    emailId:any;
    primaryMobileNumber:any;
    accountStatus:any;
    status:any
}